import {_serializeSingle, _serializeList} from '../core';
import type {ServerData} from '../core';

export function serializeDocumentProcessHistory(data: ServerData) {
    return _serializeSingle("documentProcessHistory", data);
}

export function serializeDocumentProcessHistoryList(data: ServerData) {
    return _serializeList("documentProcessHistory", data);
}
